import {DependencyList, RefObject, useEffect, useLayoutEffect, useRef} from 'react';

export function useDomElementRef<ELEMENT extends Element | Window = Element> (
    elementResolver: () => ELEMENT,
    deps: DependencyList
) : RefObject<ELEMENT> {

    const elementRef = useRef<ELEMENT | null>(null);

    useLayoutEffect(() => {

        elementRef.current = elementResolver();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return elementRef;
}

export function useDomElementRefDelayed<ELEMENT extends Element | Window = Element> (
    elementResolver: () => ELEMENT,
    deps: DependencyList
) : RefObject<ELEMENT> {

    const elementRef = useRef<ELEMENT | null>(null);

    useEffect(() => {

        elementRef.current = elementResolver();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return elementRef;
}
